module.exports = __webpack_public_path__ + "static/media/vr.bdeb1855.webp";